const actionTypes = {
  SET_MULTI_CARTS_COUNT: 'setMultiCartsCount',
  SET_SEND_CART_DOCUMENT: 'setSendCartDocument',
  SET_MODAL_DELETE_SEND_DOCUMENT_ACTIVED: 'setModalDeleteSendDocumentActived',
  SET_MODAL_DELETE_SEND_RECIPIENT_ACTIVED: 'setModalDeleteSendRecipient',
  SET_SEND_CART_MESSAGE: 'setSendCartMessage',
  SET_SEND_CART_RECIPIENT: 'setSendCartRecipient',
  SET_MODAL_RECIPIENT_SELECT_ACTIVED: 'setModalRecipientSelectActived',
  SET_MODAL_CLEAR_SEND_CART_ACTIVED: 'setModalClearSendCartActived',
  SET_DELETE_SEND_CART_RECIPIENT: 'setDeleteSendCartRecipient',
  SET_DELETE_SEND_CART_DOCUMENT: 'setDeleteSendCartDocument',
  //step1 送信先マスタを選択
  INIT_RECIPIENT_MASTER_OPTIONS: 'initRecipientMasterOptions',
  SET_RECIPIENT_MASTER_OPTIONS: 'setRecipientMasterOptions',
  CLEAR_RECIPIENT_MASTER_OPTIONS: 'clearRecipientMasterOptions',
  //step2 取引先を選択
  INIT_RECIPIENT_CLIENT_LIST: 'initRecipientCLientList',
  SET_RECIPIENT_CLIENT_LIST: 'setRecipientClientList',
  SET_DISPLAY_CLIENT_LIST: 'setDisplayClientList',
  SET_SELECTED_CLIENT: 'setSelectedClient',
  //step3 担当者を選択
  SET_RECIPIENT_CORPORATE_INFO: 'setRecipientCorporateInfo',
  SET_RECIPIENT_USER_LIST: 'setRecipientUserList',
  CLEAR_RECIPIENT_USER_LIST: 'clearRecipientUserList',
  SET_SELECTED_USER: 'setSelectedUser',
  //step4 送信先フォルダを選択
  SET_RECIPIENT_FOLDER_TREE_LIST: 'setRecipientFolderTreeList',
  CLEAR_RECIPIENT_FOLDER_TREE_LIST: 'clearRecipientFolderTreeList',
  SET_SELECTED_FOLDER_TREE: 'setSelectedFolderTree',
  //チェックエラー
  SET_CHECK_ERRORS: 'setCheckErrors',
  SET_MODAL_SEND_FINISHED_ACTIVED: 'setModalSendFinishedActived',
  SET_CONFIRM_PAGE_INIT_ERROR_DATAS: 'setConfirmPageInitErrorDatas',
  //ソートマック
  SET_SORT_COLUMN_EXIST: 'setSortColumnExist',
  SET_SORT_COLUMN_RECIPIENT_EXIST: 'setSortColumnRecipientExist',
}

export default actionTypes
